// material-ui
import { alpha, Theme } from "@mui/material/styles";

// ==============================|| OVERRIDES - DIALOG TITLE ||============================== //

export default function DialogTitle(theme: Theme) {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2.75, 3, 2),
          fontSize: "1.125rem",
          fontWeight: 700,
          letterSpacing: "-0.02em",
          lineHeight: 1.2,
          color: theme.palette.text.primary,
          borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          background: `linear-gradient(180deg, ${alpha(
            theme.palette.primary.light,
            0.14,
          )} 0%, ${alpha(theme.palette.background.paper, 0)} 100%)`,
        },
      },
    },
  };
}
